<template>
  <div class="submit-match-wrap">
    <group>
      <div @click="handleFocuDealer">
        <x-input title='选择车商' v-model="dealer" is-link readonly></x-input>
      </div>
      <x-input :class="{'price-verify': !isVerify}" title='撮合价格' type="number" v-model="price" :max="11">
        <span slot="right">元</span>
      </x-input>
    </group>
    <!-- 选择车商的列表 -->
    <actionsheet v-model="showDealer" :menus="dealerMenu" theme="ios" show-cancel @on-click-menu="handleClickDealer" class="submit-match-actionsheet">
      <div slot="header">
        <div class="title">请选择车商</div>
        <span class="tips">仅支持按出价金额从高到低依次撮合，本次撮合可选车商为：</span>
      </div>
    </actionsheet>
    <!-- 备注 -->
    <group title="备注" class="submit-match-shadow">
      <x-textarea v-model="note" placeholder="请输入内容（非必填）"></x-textarea>
    </group>
    <div class="hint">
      <p>注：</p>
      <p>1、车商需要在提交撮合的2小时内接受撮合交易，否则视为撮合失败</p>
      <p>2、车商接受撮合时将被冻结{{enquiryConfig.frozen_amount | transformMoneyNoDecimal}}元保证金，交易成功时将被扣除{{enquiryConfig.commission_amount | transformMoneyNoDecimal}}元信息服务费。</p>
    </div>
    <!-- 提交按钮 -->
    <div class="submit-match-bottom">
      <p class="submit-protocol-hint">
        <span>提交撮合即代表阅读并同意</span>
        <router-link to="/protocol/match">撮合协议</router-link>
      </p>
      <x-button type="primary" class="btn" @click="submitMatch">提交撮合</x-button>
    </div>
    <!-- 价格提醒 begin-->
    <x-alert v-model="dialogShow" button-text="我知道了" title="金额防错提示" class="verify-dialog">
      <h4 class="tips">当前的单位为“元”，你所输入的以下金额小于100元，请确认金额输入是否正确。</h4>
      <p v-for="(item, index) in dialogContent" :key="index">{{item}}</p>
    </x-alert>
    <!-- 价格提醒 end -->
  </div>
</template>
<script>
// 出价信息
import { Decimal } from 'decimal.js'
import { XButton, XInput, Group, XTextarea, Actionsheet, XAlert } from '@lx-frontend/cvux'
import util from '../../common/util'
export default {
  components: {
    XButton,
    XInput,
    XTextarea,
    Actionsheet,
    Group,
    XAlert
  },
  data() {
    return {
      dialogShow: false,
      isVerify: true, // 是否执行金额验证
      dialogContent: [], // 提示文本
      auctionId: 0, // 拍卖ID
      price: '', // 撮合价格
      showDealer: false, // 控制车商列表的弹窗
      dealer: '',
      dealerArr: [],
      dealerId: 0,
      note: '', // 备注
      dealerMenu: {},
      isEnquirySubmit: false,
      enquiryConfig: {}, // 询价配置信息
      source: '' // 只有在撮合情况下使用，区分线索询价撮合还是车辆询价撮合
    }
  },
  created() {
    // 即是询价撮合id也是流拍撮合id
    this.auctionId = +this.$route.params.id
    // 用于区分是否是提交询价撮合，如果是则提交到询价撮合接口、否则提交到流拍撮合接口
    // type等于enquiry 表示询价、其他表示流拍
    this.isEnquirySubmit = this.$route.query.type === 'enquiry'
    this.source = this.$route.query.source
    // 获取场次配置信息
    this.getSessionConfig()
  },
  methods: {
    /**
       * 获取场次配置信息（保证金、佣金）
       */
    async getSessionConfig () {
      let res
      if (this.isEnquirySubmit) {
        res = await this.$rest.match.getEnquiryMatchConfig({ enquiry_id: this.auctionId })
      } else {
        res = await this.$rest.match.getAuctionMatchConfig({ auction_id: this.auctionId })
      }
      if (res.code === 0) {
        this.enquiryConfig = res.data
      } else {
        this.showToast(res.message)
      }
    },
    handleFocuDealer () {
      this.showDealer = true

      // 询价撮合和流拍撮合车商选择接口不一样
      // 询价撮合为：/api/v1/auctions/auction_car_enquiries/<int:enquiry_id>/matchable_dealer_users
      // 流拍撮合为：/api/v1/auctions/<int:auctionId>/matchable_dealer_users

      // 通过判断isEnquirySubmit来设置不同的车商查询链接
      let dealerLink, optionLabel
      if (this.isEnquirySubmit) {
        // 说明是询价撮合车商选择
        dealerLink = `auction_car_enquiries/${this.auctionId}/matchable_dealer_users`
        // 车商选择提示文字
        optionLabel = '最高报价'
      } else {
        // 说明是流拍撮合车商选择
        dealerLink = `${this.auctionId}/matchable_dealer_users`
        // 车商选择提示文字
        optionLabel = '最高出价'
      }

      this.$rest.match.getMatchDealer(null, dealerLink).then(res => {
        if (res.code === 0) {
          this.dealerArr = res.data.candidates
          let dealers = {}
          res.data.candidates.forEach((item, index) => (
            dealers[index] = `${item.dealer_name} ${item.mobile} ${item.city}</br><span class="bid-text">${optionLabel}：${(item.max_price / 1000000).toFixed(2)}万元</span>`
          ))
          this.dealerMenu = dealers
        } else {
          this.showToast(res.message)
        }
      })
    },
    handleClickDealer (menuKey, menuItem) {
      let reg = /(\S)+(?=\s)/g
      // this.dealer = menuItem.match(reg)[0]
      // fix-sentry: match undefined。
      this.dealer = ((menuItem || '').match(reg) || [])[0]
      this.dealerId = +this.dealerArr[+menuKey]['dealer_id']
      this.price = parseFloat((this.dealerArr[+menuKey]['max_price'] / 100).toFixed(2))
    },
    // 提交撮合
    submitMatch () {
      if (!this.price) {
        this.showToast('请填写撮合价格！')
        return false
      } else if (!util.regexpMap.regexp_decimals.test(this.price)) {
        this.showToast('实收金额必须为正数并且至多2位小数')
        return false
      }
      if (!this.dealerId) {
        this.showToast('请选择车商！')
        return
      }
      if (this.isVerify) {
        const ispass = this.priceVerify()
        if (!ispass) {
          return false
        }
      }
      let params = {
        match_price: new Decimal(+this.price).mul(100).toNumber(), // 撮合价格，单位：分
        match_dealer_id: +this.dealerId, // 撮合车商id
        note: this.note
      }

      let postLink
      // 判断是流拍撮合还是询价撮合提交
      if (this.isEnquirySubmit) {
        // 询价撮合提交
        params.enquiry_id = this.auctionId
        postLink = `auction_car_enquiries/${this.auctionId}/submit_enquiry_match`
      } else {
        // 流拍撮合提交
        params.auction_id = this.auctionId
        postLink = `${this.auctionId}/submit_auction_match`
      }

      this.$rest.match.postMatch(params, postLink).then(res => {
        if (res.code === 0) {
          // 增加标志用于提示页面跳转到不同的撮合管理页面 enquiry 表示 询价 auction 表示 流拍撮合
          let type = ''
          let queryParams = {}
          // 询价撮合增加参数区分 线索询价撮合还是车辆询价撮合
          // 询价撮合操作成功页面需要根据 source 参数 跳转到不同链接
          if (this.isEnquirySubmit) {
            type = 'enquiry'
            queryParams.source = this.source
          } else {
            type = 'auction'
          }
          queryParams.type = type
          // 询价和流拍的ID不同响应字段
          let urlId = this.isEnquirySubmit ? res.data.enquiry_id : res.data.auction_id
          this.$router.push({ path: `/auction/match/suc/${urlId}`, query: queryParams })
        } else {
          this.showToast(res.message)
        }
      })
    },
    // 金额防错提示
    priceVerify() {
      if (this.price < 100) {
        this.dialogContent.push(`撮合价格：${this.price}元`)
      }
      if (this.dialogContent.length > 0) {
        this.dialogShow = true
        this.isVerify = false
        return false
      }
      return true
    }
  }
}
</script>

<style lang="less">
@import "../../stylesheets/modules/auction/submitMatch.less";
@import '../../stylesheets/base/mixin/common.less';
</style>
